/**
 * Tariftabelle (templates/product-details/_pricing-table.twig)
 *
 * 1) "Alle Leistungen anzeigen" (.services-foldout + .is-expanded)
 * 2) Erklärung pro Leistung als Akkordeon: [data-benefit-toggle="<rowId>"].
 *    - max. eine Leistung pro Tabelle ([data-pricing-table]) offen
 *    - alle Toggles derselben Leistung (Desktop + jede Mobile-Tarifkarte) teilen
 *      den Zustand → beim Tarifwechsel auf Mobile bleibt die Leistung geöffnet.
 */

function syncVisibleServicesFoldout(listEl, expanded) {
	if (!listEl) return;

	listEl.setAttribute('data-services-expanded', expanded ? 'true' : 'false');

	const visibleCard = listEl.querySelector('.insurance-type:not(.hidden)');
	if (!visibleCard) return;

	const foldout = visibleCard.querySelector('.services-foldout');
	const toggle = visibleCard.querySelector('.toggle-show-all-services');

	if (foldout) foldout.classList.toggle('is-expanded', expanded);
	if (toggle) toggle.setAttribute('aria-expanded', String(expanded));
}

function setOpenBenefit(root, rowId) {
	root.dataset.openBenefit = rowId || '';

	root.querySelectorAll('[data-benefit-toggle]').forEach((toggle) => {
		const isOpen = Boolean(rowId) && toggle.dataset.benefitToggle === rowId;
		toggle.setAttribute('aria-expanded', String(isOpen));

		const panel = document.getElementById(toggle.getAttribute('aria-controls'));
		if (panel) panel.hidden = !isOpen;
	});
}

document.querySelectorAll('[data-pricing-table]').forEach((root) => {
	root.addEventListener('click', (event) => {
		const toggle = event.target.closest('[data-benefit-toggle]');
		if (!toggle || !root.contains(toggle)) return;

		const rowId = toggle.dataset.benefitToggle;
		setOpenBenefit(root, root.dataset.openBenefit === rowId ? '' : rowId);
	});
});

document.querySelectorAll('.toggle-show-all-services').forEach((toggle) => {
	toggle.addEventListener('click', () => {
		const container = toggle.closest('.services-foldout');
		if (!container) return;

		const isExpanded = container.classList.toggle('is-expanded');
		toggle.setAttribute('aria-expanded', String(isExpanded));

		const list = toggle.closest('.insurance-type-list');
		if (list) {
			syncVisibleServicesFoldout(list, isExpanded);
		}

		// Beim Einklappen eine geöffnete, nun versteckte Leistung schließen
		const root = toggle.closest('[data-pricing-table]');
		if (!isExpanded && root && root.dataset.openBenefit) {
			const openToggle = container.querySelector(
				`[data-benefit-toggle="${root.dataset.openBenefit}"]`,
			);
			if (openToggle?.closest('.service-foldout-row--collapsible')) {
				setOpenBenefit(root, '');
			}
		}
	});
});

document.querySelectorAll('.insurance-type-list').forEach((list) => {
	list.addEventListener('insurance-type:change', () => {
		const expanded = list.getAttribute('data-services-expanded') === 'true';
		syncVisibleServicesFoldout(list, expanded);
	});
	syncVisibleServicesFoldout(list, false);
});
